export default "__VITE_ASSET__C6IcM50x__"